import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import InVestLogo from '../../assets/SideNavbar/sideNavInvestLogo.svg';
import './css/SideNavBar.css';
import sideDash from '../../assets/SideNavbar/Dashboard.svg';
import sideDashW from '../../assets/SideNavbar/Dashboard-w.svg';
import userProfileDash from '../../assets/SideNavbar/user.svg';
import userProfileDashW from '../../assets/SideNavbar/user-w.svg';
import referAndEarnI from '../../assets/SideNavbar/marketing-flow.svg';
import referAndEarnW from '../../assets/SideNavbar/marketing-flow-w.svg';

import DematIconDash from '../../assets/SideNavbar/DematIcon.svg';
import DematIconDashW from '../../assets/SideNavbar/DematIcon-w.svg';

import subscriptionDash from '../../assets/SideNavbar/IPOIcon.svg';
import subscriptionDashW from '../../assets/SideNavbar/IPOIcon-w.svg';
import transactionDash from '../../assets/SideNavbar/TransactionIcon.svg';
import transactionDashW from '../../assets/SideNavbar/TransactionIcon-w.svg';

import { useLocation } from 'react-router-dom';
import { Context } from '../../services/apiContext';

export default function SideNav() {
  let location = useLocation();
  const [showNav, setshowNav] = useState(false);
  const toggleNav = (that) => {
    setshowNav(!showNav);
  };
  const contextapi = useContext(Context);

  const [showRefer, setShowRefer] = useState(true);

  const [path, setpath] = useState('');
  useEffect(() => {
    let cseData = contextapi.getSession('cseData');
    if (cseData) {
      setShowRefer(false);
    }

    setpath(location.pathname);
  }, [location.pathname]);

  return (
    <div className='row marginAuto'>
      <div className='col hidmob'>
        <div className='d-md-flex hide-md'>
          <nav id='sidebar' className='pt-5 mt-2'>
            <ul className='components pb-3'>
              <li
                className={`mt-2  newLihover ${
                  path === '/Home/dashboard' ? 'highlightONSelectedPage' : ''
                }`}
              >
                <p className='sideNavList'>
                  <Link className='sideNewA sideNewA_initial' to={'dashboard'}>
                    <img src={sideDash} alt='img' className='sideDash' />{' '}
                    Dashboard
                  </Link>

                  <Link className='sideNewA sideNewA_onhover' to={'dashboard'}>
                    <img src={sideDashW} alt='img' className='sideDash' />{' '}
                    Dashboard
                  </Link>
                </p>

                {/* <Link className="dash text-decoration-none" to="dashboard">
                                    <p className="menu-item">Dashboard</p>
                                </Link> */}
              </li>
              <li
                className={`mt-2  newLihover ${
                  path === '/Home/userProfile' ? 'highlightONSelectedPage' : ''
                }`}
              >
                {/* <Link
                                    className="user text-decoration-none"
                                    to={"userProfile"}
                                >
                                    <p className="menu-item">User Profile</p>
                                </Link> */}

                <p className='sideNavList'>
                  <Link
                    className='sideNewA sideNewA_initial'
                    to={'userProfile'}
                  >
                    <img src={userProfileDash} alt='img' className='sideDash' />{' '}
                    My Profile
                  </Link>

                  <Link
                    className='sideNewA sideNewA_onhover'
                    to={'userProfile'}
                  >
                    <img
                      src={userProfileDashW}
                      alt='img'
                      className='sideDash'
                    />{' '}
                    My Profile
                  </Link>
                </p>
              </li>
              <li
                className={`mt-2  newLihover creatDemathover ${
                  path === '/Home/createDemat' ? 'highlightONSelectedPage' : ''
                }`}
              >
                <p className='sideNavList'>
                  <Link
                    className='sideNewA sideNewA_initial'
                    to={'createDemat'}
                  >
                    <img src={DematIconDash} alt='img' className='sideDash' />{' '}
                    Demat
                  </Link>

                  <Link
                    className='sideNewA sideNewA_onhover'
                    to={'createDemat'}
                  >
                    <img src={DematIconDashW} alt='img' className='sideDash' />{' '}
                    Demat
                  </Link>
                </p>

                {/* <Link
                                    className="demat text-decoration-none"
                                    to={"createDemat"}
                                >
                                    <p className="menu-item">Demat</p>
                                </Link> */}
                <div className='viewSummaryBocDashboardTop'>
                  <p>Create new Demat account</p>
                </div>
              </li>
              {showRefer && (
                <li
                  className={`mt-2  newLihover ${
                    path === '/home/referral' ? 'highlightONSelectedPage' : ''
                  }`}
                >
                  <p className='sideNavList'>
                    <Link className='sideNewA sideNewA_initial' to={'referral'}>
                      <img src={referAndEarnI} alt='img' className='sideDash' />{' '}
                      Refer and Earn
                    </Link>

                    <Link className='sideNewA sideNewA_onhover' to={'referral'}>
                      <img src={referAndEarnW} alt='img' className='sideDash w-20' />{' '}
                      Refer and Earn
                    </Link>
                  </p>
                </li>
              )}

              {/* <li className={`mt-2  newLihover ${path === "/Home/IPO" ? "highlightONSelectedPage" : ""}`}>
                               
                  <p className="sideNavList">
                      <Link
                          className="sideNewA sideNewA_initial"
                          to={"IPO"}
                      >
                          <img src={subscriptionDash} alt='img' className="sideDash" />  IPO Subscription
                      </Link>

                      <Link
                          className="sideNewA sideNewA_onhover"
                          to={"IPO"}
                      >
                          <img src={subscriptionDashW} alt='img' className="sideDash" />  IPO Subscription
                      </Link>
                  </p>

              </li>
              
              <li className={`mt-2  newLihover ${path === "/Home/transactions" ? "highlightONSelectedPage" : ""}`}>
                  

                  <p className="sideNavList">
                      <Link
                          className="sideNewA sideNewA_initial"
                          to={"IPO/transactions"}
                      >
                          <img src={transactionDash} alt='img' className="sideDash" /> IPO Transactions
                      </Link>

                      <Link
                          className="sideNewA sideNewA_onhover"
                          to={"IPO/transactions"}
                      >
                          <img src={transactionDashW} alt='img' className="sideDash" /> IPO Transactions
                      </Link>
                  </p>

              </li>  */}

            </ul>
            <div className='easy-invest mx-auto text-center extraMArgintop'>
              <div className='logoDiv'>
                <img src={InVestLogo} alt='Investlogo' className='logo' />
              </div>
              <div className='LogoInvDiv'>
                <p className='LogoInvestText'>
                  We make it <span>Easy</span> for every one to Invest
                </p>
                {/* <button className="btn-more custommore">More</button> */}
              </div>
            </div>
          </nav>
        </div>
      </div>

      {/* <>Mobile </> */}
      <div className='navbarMobile'>
        <a href='#home' className='active'>
          Home
        </a>
        <a href='#news'>Subscriptions</a>
        <a>
          {' '}
          <button className='navbar-toggler' type='button' onClick={toggleNav}>
            <span className='navbar-toggler-icon'></span>
          </button>
          Menu
        </a>

        <div className={(showNav ? 'showDropdown' : '') + ' mobilecollapse'}>
          <ul className='navbar-nav mr-auto'>
            <li className='mt-2'>
              <Link className='user text-decoration-none' to={'userProfile'}>
                <p className='menu-item'>My Profile</p>
              </Link>
            </li>
            <li className='mt-2'>
              <Link className='demat text-decoration-none' to={'dematDetails'}>
                <p className='menu-item'>Demat</p>
              </Link>
            </li>
            {/* <li className='mt-2'>
              <Link
                className='transactions text-decoration-none'
                to='transactions'
              >
                <p className='menu-item'>Transactions</p>
              </Link>
            </li> */}
            ...
          </ul>
        </div>
      </div>
      {/* <!--mobile end */}
    </div>
  );
}